// @flow
import React from 'react';
import { isBrowser } from 'react-device-detect';
import ModalWrapper from '../ModalWrapper';
import Button from '../Button';
import './QuestionModal.scss';

type Props = {
  title?: ?string,
  description: string,
  confirmText: string,
  onConfirm: () => any,
  onCancel: () => any,
  open: boolean,
  confirmBtnColor?: string,
};

const QuestionModal = ({
  title,
  description,
  confirmText,
  onConfirm,
  onCancel,
  open,
  confirmBtnColor,
}: Props) => (
  <ModalWrapper open={open}>
    <div className="QuestionModal">
      <div className="modal-content">
        {title && <h4>{title}</h4>}
        <p>{description}</p>
        <div className="button-area">
          <Button cancel onClick={onCancel} desktop={isBrowser}>
            취소
          </Button>
          <Button color={confirmBtnColor} onClick={onConfirm} desktop={isBrowser}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  </ModalWrapper>
);

QuestionModal.defaultProps = {
  title: null,
  confirmText: '확인',
};

export default QuestionModal;



// WEBPACK FOOTER //
// ./src/components/common/QuestionModal/QuestionModal.js